import React from 'react';
import "./business.css";
import BusinessImg from "../../assets/tagline-and-imagetype-white.svg";
import CV from "../../assets/John-Cv.pdf";
import Info from './Info';
import Testimonials from './Testimonials';
import banner from "../../assets/house-painter-wo-background.png"

const Business = () => {


  return (
    <section className="business" id="business">
      
        <div className="business__container grid">
        <img src={BusinessImg} alt="" className="business__img" />
            <div className="business__data">
              <p className='business__text'>Welcome to Emanuel Pro Painting LLC, your trusted partner for all your painting needs. We specialize in turning houses into homes and commercial into living environments through the power of color and craftsmanship. </p>
            </div>
        </div>
    </section>
  )
}

export default Business
